export default __webpack_public_path__ + "static/media/Icon-Red-Alert-Circle.4fa59493.svg";